"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldName = fieldName;
function fieldName(field) {
    if (!field.field) {
        throw new Error('Invalid attribute object: no field property');
    }
    return field.shortName || field.alias || field.field;
}
//# sourceMappingURL=field-name.js.map